import React, {useEffect, useMemo} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {compact} from "@pg-mono/nodash";

import {fetchPropertyDetailPoi} from "../../offer/detail/actions/fetch_offer_detail_poi";
import {Country} from "../../region/types/Country";
import {useGetOfferDetailTransportPoiQuery} from "../api/get_offer_detail_poi";
import {usePois} from "../hooks/use_pois";
import {useTransportPoisStats} from "../hooks/use_transport_pois";
import {IPoi} from "../types/IPoi";
import {getPoiUIData, PoiType, TransportPoiType} from "../utils/PoiType";
import {PoiItemWithTooltip} from "./PoiItemWithTooltip";

interface IProps {
    offer: {
        id: number;
        geo_point: {
            coordinates: [number, number];
        };
        region: {
            country: Country;
        };
    };
    className?: string;
}

export const PoiItemsList = (props: IProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchPropertyDetailPoi(props.offer.geo_point.coordinates, props.offer.region.country));
    }, [props.offer]);

    const {data: poiData} = useGetOfferDetailTransportPoiQuery(props.offer.id);

    const {subwayPoi, railwayPoi, tramPoi, busPoi} = useTransportPoisStats();

    const subwayOrRailwayPoi = subwayPoi || railwayPoi;

    const {educationPois, healthPois, shopPois, sportPois} = usePois(poiData && poiData.poi ? poiData.poi.pois : ({} as Record<PoiType, IPoi[]>));

    const educationPoi = educationPois[0];
    const healthPoi = healthPois[0];
    const shopPoi = shopPois[0];
    const sportPoi = sportPois[0];

    const pois = useMemo(() => {
        const items = [
            getPoiUIData(busPoi, PoiType.TRANSPORT, TransportPoiType.BUS),
            getPoiUIData(tramPoi, PoiType.TRANSPORT, TransportPoiType.TRAM),
            getPoiUIData(shopPoi, PoiType.SHOPS),
            getPoiUIData(educationPoi, PoiType.EDUCATION),
            getPoiUIData(sportPoi, PoiType.SPORT),
            getPoiUIData(healthPoi, PoiType.HEALTH)
        ];

        if (subwayOrRailwayPoi) {
            items.unshift(getPoiUIData(subwayOrRailwayPoi, PoiType.TRANSPORT, !!subwayPoi ? TransportPoiType.SUBWAY : TransportPoiType.RAILWAY));
        }

        return compact(items);
    }, [subwayPoi, railwayPoi, busPoi, tramPoi, educationPois, healthPois, shopPois, sportPois]);

    return (
        <div className={cx(css({display: "flex", pt: 1, pb: 4}), props.className)}>
            {pois.map((poi, index) => (
                <PoiItemWithTooltip key={poi.subType || poi.type} distance={poi.distance} icon={poi.icon} id={index} name={poi.name} title={poi.title} />
            ))}
        </div>
    );
};
import React, {useEffect, useMemo} from "react";
import {useDispatch} from "react-redux";
import {css, cx} from "@panda/css";

import {compact} from "@pg-mono/nodash";

import {fetchPropertyDetailPoi} from "../../offer/detail/actions/fetch_offer_detail_poi";
import {Country} from "../../region/types/Country";
import {useGetOfferDetailTransportPoiQuery} from "../api/get_offer_detail_poi";
import {usePois} from "../hooks/use_pois";
import {useTransportPoisStats} from "../hooks/use_transport_pois";
import {IPoi} from "../types/IPoi";
import {getPoiUIData, PoiType, TransportPoiType} from "../utils/PoiType";
import {PoiItemWithTooltip} from "./PoiItemWithTooltip";

interface IProps {
    offer: {
        id: number;
        geo_point: {
            coordinates: [number, number];
        };
        region: {
            country: Country;
        };
    };
    className?: string;
}

export const PoiItemsList = (props: IProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchPropertyDetailPoi(props.offer.geo_point.coordinates, props.offer.region.country));
    }, [props.offer]);

    const {data: poiData} = useGetOfferDetailTransportPoiQuery(props.offer.id);

    const {subwayPoi, railwayPoi, tramPoi, busPoi} = useTransportPoisStats();

    const subwayOrRailwayPoi = subwayPoi || railwayPoi;

    const {educationPois, healthPois, shopPois, sportPois} = usePois(poiData && poiData.poi ? poiData.poi.pois : ({} as Record<PoiType, IPoi[]>));

    const educationPoi = educationPois[0];
    const healthPoi = healthPois[0];
    const shopPoi = shopPois[0];
    const sportPoi = sportPois[0];

    const pois = useMemo(() => {
        const items = [
            getPoiUIData(busPoi, PoiType.TRANSPORT, TransportPoiType.BUS),
            getPoiUIData(tramPoi, PoiType.TRANSPORT, TransportPoiType.TRAM),
            getPoiUIData(shopPoi, PoiType.SHOPS),
            getPoiUIData(educationPoi, PoiType.EDUCATION),
            getPoiUIData(sportPoi, PoiType.SPORT),
            getPoiUIData(healthPoi, PoiType.HEALTH)
        ];

        if (subwayOrRailwayPoi) {
            items.unshift(getPoiUIData(subwayOrRailwayPoi, PoiType.TRANSPORT, !!subwayPoi ? TransportPoiType.SUBWAY : TransportPoiType.RAILWAY));
        }

        return compact(items);
    }, [subwayPoi, railwayPoi, busPoi, tramPoi, educationPois, healthPois, shopPois, sportPois]);

    return (
        <div className={cx(css({display: "flex", pt: 1, pb: 4}), props.className)}>
            {pois.map((poi, index) => (
                <PoiItemWithTooltip key={poi.subType || poi.type} distance={poi.distance} icon={poi.icon} id={index} name={poi.name} title={poi.title} />
            ))}
        </div>
    );
};
